import { useFuse } from 'shared/domains/common-utils/useFuse';
/**
 * Provides in-memory fuzzy search functionality for SearchableMenu components using Fuse.js.
 *
 * This hook wraps the `useFuse` hook to provide a search interface that's compatible with
 * SearchableMenuProvider.
 */
export function useSearchableMenuFuse(items, options) {
    const { search, reset, result } = useFuse(items, Object.assign({ 
        // SearchableMenu applies a debounce itself
        delay: 0 }, options));
    return {
        onSearch: search,
        onReset: reset,
        items: result,
    };
}
